import { Injectable } from '@angular/core';

import { AuthService } from './auth.service';
import { AppHelperService } from './app-helper.service';

@Injectable()
export class isUserAuthentcatedRoutesGuard  {

    constructor(
        private authService: AuthService,
        private appHelperService: AppHelperService
    ) { }

    canActivate(): boolean | Promise<boolean> {
        return this.authService.getUserDataFromSession().then(userData => {
            return this.authService.checkGigyaAndServerSession().then(() => {
                if (userData && userData.role) {
                    switch (userData.role) {
                        case 'student': this.appHelperService.navigateToDashboardApp(['learner/dashboard']); break;
                        case 'teacher': this.appHelperService.navigateToDashboardApp([]); break;
                        case 'admin': this.appHelperService.navigateToAdminApp(['admin', 'dashboard']); break;
                        default: this.appHelperService.navigateToOnboardingApp(['home']);
                    }
                    return true;
                } else {
                    this.authService.rurl = window.location.pathname + window.location.search;
                    this.authService.navigateToRurl();
                }
            });
        });
    }
}
